export default {
	field: 'productClass.classification',
	name: 'Classification',
}
